export const SCHEDULED_MESSAGES_RESCHEDULE_MODAL_ID =
  'scheduled-messages-reschedule-modal';
